import {v4 as uniqueId} from 'uuid';

export function generateKey() {
	return uniqueId();
}
